import { runtimeConfig } from '@/shared/config'

// Публичный вход MSW-мока: сам мок грузится dynamic import'ом (отдельный чанк,
// выпадает из прод-бандла), поэтому app/init не лезет в @/shared/api/mock напрямую.
export async function startMocking(): Promise<void> {
  if (runtimeConfig.API_MODE !== 'mock') return
  const { startMockWorker } = await import('./mock')
  await startMockWorker()
}
